import React from 'react';

import { Loading } from './styles';

export default function LoadingComponent() {
  return (
    <Loading >
      <div />
    </Loading>
  );
}
